var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explanation"},[_c('span',{staticClass:"bold"},[_vm._v("לפירוט")]),_vm._v("\n   לחצו על הקטגוריה\n")])}]

export { render, staticRenderFns }